export const reasoningResources = {
  fr: {
    run: 'Raisonnement Run', build: 'Raisonnement Build',
    auto: 'Automatique (provider)', none: 'Désactivé', minimal: 'Minimal',
    low: 'Faible', medium: 'Moyen', high: 'Élevé', xhigh: 'Très élevé', max: 'Maximum',
    unavailable: 'Aucun profil LLM disponible',
    incompatible: 'Cet effort n’est pas compatible avec ce modèle. Choisissez explicitement une valeur compatible ou Automatique avant de changer de modèle.',
    saveFailed: 'Impossible d’enregistrer le réglage.', saved: 'Réglage enregistré.',
    profileName: '{{role}} · {{agent}}',
  },
  en: {
    run: 'Run reasoning', build: 'Build reasoning',
    auto: 'Automatic (provider)', none: 'Off', minimal: 'Minimal',
    low: 'Low', medium: 'Medium', high: 'High', xhigh: 'Extra high', max: 'Maximum',
    unavailable: 'No LLM profile available',
    incompatible: 'This effort is incompatible with this model. Explicitly select a supported value or Automatic before changing models.',
    saveFailed: 'Could not save the setting.', saved: 'Setting saved.',
    profileName: '{{role}} · {{agent}}',
  },
  es: {
    run: 'Razonamiento Run', build: 'Razonamiento Build',
    auto: 'Automático (proveedor)', none: 'Desactivado', minimal: 'Mínimo',
    low: 'Bajo', medium: 'Medio', high: 'Alto', xhigh: 'Muy alto', max: 'Máximo',
    unavailable: 'No hay ningún perfil LLM disponible',
    incompatible: 'Este esfuerzo no es compatible con este modelo. Selecciona explícitamente un valor compatible o Automático antes de cambiar de modelo.',
    saveFailed: 'No se pudo guardar el ajuste.', saved: 'Ajuste guardado.',
    profileName: '{{role}} · {{agent}}',
  },
}
